import { type ISbStoryData } from "@storyblok/react/rsc";
import type { BaseSBType } from "../../type-generators";
import { StoryblokComponent } from "../StoryblokComponent/StoryblokComponent";
import { ClientStoryblokStory } from "./ClientStoryblokStory";

export type StoryblokStoryProps = {
  story: ISbStoryData;
  preview: boolean;
  /**
   * Toggle this to prevent StoryblokStory mounting a bridge to Storyblok during preview
   * Useful when using StoryblokStory within a nested StoryblokStory where bridge is already enabled
   */
  bridgeLess?: boolean;
  [key: string]: unknown;
};

export const StoryblokStory = ({
  story,
  preview,
  ...rest
}: StoryblokStoryProps) => {
  if (preview) {
    return <ClientStoryblokStory {...rest} preview story={story} />;
  }

  return (
    <StoryblokComponent
      {...rest}
      preview={preview}
      blok={story?.content as BaseSBType}
    />
  );
};
